<template>
  <div class="home-title-bar">
    <div class="header-left">
      <button class="header-menu btn-icon menu" @click="clickMenu()">메뉴</button>
      <h1 @click="goMain()" class="home-title">
        <img src="@/assets/images/logo-desimone.svg" alt="드시모네몰" />
      </h1>
    </div>
    <div class="header-right">
      <div class="header-util">
        <button class="btn-icon search" @click="clickSearch()">검색</button>
        <button class="btn-icon mypage" @click="clickMyPage()">마이페이지</button>
        <button class="btn-icon cart" @click="clickCart()">
          장바구니
          <span class="cart-badge" v-if="store.cartCount > 0">{{ store.cartCount }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/* interface PropsType {
  cartCount: number;
}

const props = withDefaults(defineProps<PropsType>(), {
  cartCount: 0
}); */

const store = useMainStore();

const clickMyPage = (): void => {
  goMyPage();
};

const clickSearch = (): void => {
  navigateTo('/goods/search');
};

const clickCart = (): void => {
  goCart();
};

const clickMenu = (): void => {
  const html = document.querySelector('html') as HTMLElement | null;
  const leftMenu = document.querySelector('.leftMenu') as HTMLElement | null;
  
  if (html && leftMenu) {
    leftMenu.classList.add('show');
    html.style.overflow = "hidden";
  }
};

const goMain = (): void => {
  navigateTo('/');
};
</script>